var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row level-container mx-md-0" },
    [
      _vm._l(_vm.levels, function(item, index) {
        return _c(
          "div",
          {
            key: `legend-index-${index}`,
            staticClass: "col p-0 d-flex flex-column rounded"
          },
          [
            _c("div", { staticClass: "d-flex flex-column" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-center align-items-center py-1",
                  style: `background-color: ${item.color}`
                },
                [
                  _c(
                    "div",
                    { staticClass: "color-gray-7 font-16 font-weight-bold" },
                    [_vm._v(" " + _vm._s(item.name) + " ")]
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "border-color--gray-5 py-2 d-flex justify-content-center align-items-center .border-top--color-white",
                  style: {
                    "background-color": item.selected ? item.color : "#fff"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "level-container__radio cursor-pointer d-flex justify-content-center align-items-center",
                      on: {
                        click: function($event) {
                          return _vm.onSelectHandler(item, index)
                        }
                      }
                    },
                    [
                      item.selected
                        ? _c("div", {
                            staticClass: "level-container__radio--selected"
                          })
                        : _vm._e()
                    ]
                  )
                ]
              )
            ])
          ]
        )
      }),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _vm.error
            ? _c("custom-error", {
                attrs: { message: _vm.error, variant: "no-border mt-1" }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }